import {
  Box,
  Button,
  IconButton,
  MenuItem,
  Select,
  TextField,
  useTheme,
} from "@mui/material";

import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useState } from "react";
import { useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";

const columns = [
  {
    id: "typeMateriaux",
    label: "Types/Matériaux",
    type: "select",
    width: 100,
    options: [
      { label: "Mur en pierre de taille", value: "Mur en pierre de taille" },
      {
        label: "Mur simple brique pleines",
        value: "Mur simple brique pleines",
      },
      {
        label: "Mur double en brique pleines",
        value: "Mur double en brique pleines",
      },
      { label: "Mur en brique creuse", value: "Mur en brique creuse" },
      { label: "Mur en béton pleins", value: "Mur en béton pleins" },
      { label: "Mur en béton banché", value: "Mur en béton banché" },
      { label: "Mur en pans de bois", value: "Mur en pans de bois" },
      { label: "Mur en bois", value: "Mur en bois" },
      {
        label: "Mur en en pisé ou béton de terre stabilisé",
        value: "Mur en en pisé ou béton de terre stabilisé",
      },
    ],
  },
  {
    id: "presenceIsolation",
    label: "Présence d’isolation",
    type: "select",
    options: [
      { label: "non", value: "non" },
      { label: "oui", value: "oui" },
    ],
  },
  {
    id: "epaisseurIsolant",
    label: "Epaisseur de l'isolant (cm)",
    type: "number",
    condition: (values) => values.presenceIsolation === "oui",
  },
  {
    id: "anneeIsolation",
    label: "Année d’isolation",
    type: "number",
    condition: (values) => values.presenceIsolation === "oui",
  },
  {
    id: "tauxIsolation",
    label: "Taux d'isolation",
    type: "select",
    options: [
      { label: "total", value: "total" },
      { label: "partiel", value: "partiel" },
    ],
    condition: (values) => values.presenceIsolation === "oui",
  },
  {
    id: "tauxIsolationPartiel",
    label: "Taux d’isolation partiel",
    type: "number",
    condition: (values) => values.tauxIsolation === "partiel",
  },
  {
    id: "position",
    label: "Position",
    type: "select",
    options: [
      { label: "Mur Extérieur", value: "Mur Extérieur" },
      {
        label: "Mur sur Local non chauffé",
        value: " Mur sur Local non chauffé",
      },
      { label: "Mur enterré", value: "Mur enterré" },
      { label: "Mur mitoyen", value: "Mur mitoyen" },
      { label: "Mur sur bâti autre", value: "Mur sur bâti autre" },
    ],
  },
  { id: "cta", label: "Actions", minWidth: 50, align: "right" },
];

const Parois = (props) => {
  const defaultValue = {};

  let initialValue = [defaultValue];

  if (props.initialValue && props.initialValue.length > 0) {
    initialValue = props.initialValue;
  }

  const { palette } = useTheme();

  const [parois, setParois] = useState(initialValue);
  const [screenSize, setScreenSize] = useState(getCurrentDimension());

  function getCurrentDimension() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }
  useEffect(() => {
    const updateDimension = () => {
      setScreenSize(getCurrentDimension());
    };
    window.addEventListener("resize", updateDimension);

    return () => {
      window.removeEventListener("resize", updateDimension);
    };
  }, [screenSize]);

  const handleChange = (index, name, value) => {
    let newValue = Object.assign([], parois);
    newValue[index][name] = value;

    setParois(newValue);
  };

  const addParoi = () => {
    let newValue = Object.assign([], parois);
    newValue.push(defaultValue);
    setParois(newValue);
  };

  const deleteparoi = (index) => {
    setParois((prevSystems) => prevSystems.filter((_, i) => i !== index));
  };

  const submit = async () => {
    let cleanParois = Object.assign([], parois);

    cleanParois.map((cleanParoi) => {
      if (cleanParoi.presenceIsolation === "non") {
        delete cleanParoi.epaisseurIsolant;
        delete cleanParoi.anneeIsolation;
        delete cleanParoi.tauxIsolation;
        delete cleanParoi.tauxIsolationPartiel;
      } else if (cleanParoi.tauxIsolation === "total") {
        delete cleanParoi.tauxIsolationPartiel;
      }
    });

    props.onSubmit(cleanParois);
  };

  return (
    <Box>
      <Box>
        <Paper
          sx={{
            ml: "24px",
            mr: "20px",
            mt: "10px",
            overflow: "hidden",
            borderRadius: "12px",
          }}
        >
          <Box
            sx={{
              gridColumn: "span 4",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={submit}
              sx={{
                m: "12px",
                p: "10px",
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              Enregistrer
            </Button>
          </Box>
          <TableContainer sx={{ maxHeight: screenSize.height - 320 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{
                        fontSize: "16px",
                        fontWeight: 600,
                        minWidth: column.minWidth,
                        width: column.width,
                      }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {parois.map((value, index) => {
                  return (
                    <TableRow key={index} role="checkbox" tabIndex={-1}>
                      {columns.map((column) => {
                        if (column.id == "cta") {
                          return (
                            <TableCell
                              sx={{
                                fontSize: "14px",
                                fontWeight: 500,
                              }}
                              key={column.id}
                              align={column.align}
                            >
                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  deleteparoi(index);
                                }}
                                sx={{ fontSize: "25px" }}
                              >
                                <DeleteIcon
                                  sx={{
                                    color: palette.primary.red,
                                    fontSize: "25px",
                                  }}
                                />
                              </IconButton>
                            </TableCell>
                          );
                        }
                        if (column.type === "select") {
                          return (
                            <TableCell
                              sx={{
                                fontSize: "12px",
                                fontWeight: 500,
                                width: column.width,
                                minWidth: column.minWidth,
                              }}
                              key={column.id}
                              align={column.align}
                            >
                              <Select
                                disabled={
                                  column.condition
                                    ? !column.condition(value)
                                    : false
                                }
                                placeholder={column.label}
                                name={column.key}
                                labelId={column.label}
                                id={column.label}
                                value={value[column.id]}
                                label={column.label}
                                onChange={(e) =>
                                  handleChange(index, column.id, e.target.value)
                                }
                                sx={{
                                  width: column.width,
                                  minWidth: column.minWidth,
                                }}
                              >
                                {column.options.map((option, index) => {
                                  return (
                                    <MenuItem value={option.value}>
                                      {option.label}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </TableCell>
                          );
                        }
                        return (
                          <TableCell
                            sx={{
                              fontSize: "12px",
                              fontWeight: 500,
                              width: column.width,
                              minWidth: column.minWidth,
                            }}
                            key={column.id}
                            align={column.align}
                          >
                            <TextField
                              label={column.label}
                              type="text"
                              disabled={
                                column.condition
                                  ? !column.condition(value)
                                  : false
                              }
                              onChange={(e) =>
                                handleChange(index, column.id, e.target.value)
                              }
                              value={value[column.id]}
                              name={column.id}
                            />
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <Box
            sx={{
              gridColumn: "span 4",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={addParoi}
              sx={{
                m: "12px",
                p: "10px",
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              Ajouter
            </Button>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default Parois;
